// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"a4f54cd2","76":"0e0de9db","413":"d903007a","497":"18b610da","505":"b1e26180","525":"77b6a2af","569":"36fbc4d3","651":"23906357","704":"f29c1a40","897":"2c756c4c","984":"45b14c6c"}[chunkId] + ".chunk.js";
};